import client from "api/client";

import type { SearchApi } from "api/models/index";
import type { Currency } from "api/models/currency";
import type { PartnerApplicationApi, PartnerInfoApi, PartnerSearch, PartnerFullApi, PartnerCms, PartnerPaywall } from "api/models/partner";


const base = "/admin/partner";
const partner = {
	get: (id: string) => client.get<PartnerFullApi>(base + `/${id}`),
	search: (body: SearchApi<PartnerSearch>) => client.post<PartnerInfoApi[]>(base + "/search", body, { paginated: true }),
	update: (id: string, body: PartnerFullApi) => client.post<PartnerFullApi>(base + `/${id}/update`, body),
	getApplication: (id: string) => client.get<PartnerApplicationApi>(base + `/application/${id}`),
	save: (id: string, body: PartnerApplicationApi) => client.post<PartnerApplicationApi>(base + `/${id}/save`, body),
	approve: (id: string, body: PartnerApplicationApi) => client.post<PartnerApplicationApi>(base + `/${id}/approve`, body),
	reject: (id: string, body: PartnerApplicationApi) => client.post<PartnerApplicationApi>(base + `/${id}/reject`, body),
	getAllCms: () => client.get<PartnerCms[]>(base + "/cms"),
	getPaywalls: (id: string) => client.get<PartnerPaywall[]>(base + `/cms/${id}/paywalls`),
	getCurrencies: () => client.get<Currency[]>(base + "/currency")
};

export default partner;